import { styles } from "./styles";

const WaveCountdown = () => {
  return (
    <div id="waveCountdown" style={styles.waveCountdown}>
      <span>Next wave in: </span>
      <span id="wave-countdown--time">0</span>
    </div>
  );
};

export default WaveCountdown;
